// extracted by mini-css-extract-plugin
export var business__fromResponse = "index-module--business__from-response--54917";
export var business__fromResponseIcon = "index-module--business__from-response-icon--f0efd";
export var business__fromResponseText = "index-module--business__from-response-text--8b5c7";